import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/Cycle";

export const GetAll = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetAll`, options);

export const GetCycleList = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetCycleList`, options);

export const Create = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Create`, options);

export const GetById = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetById/:id`, options);

export const Update = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Update/:id`, options);

export const Delete = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Delete/:id`, options);

export const CalculateCycle = (options) =>
  GENERATE_URL(`${PREFIX_URL}/CalculateCycle`, options);

export const UpdateLockStatus = (options) =>
  GENERATE_URL(`${PREFIX_URL}/UpdateLockStatus/:id`, options);

export const GetCycleLogs = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetCycleLogs`, options);

export const ReactivateCycle = (options) =>
  GENERATE_URL(`${PREFIX_URL}/ReactivateCycle`, options);

export const CalculateMultipleCycle = (options) =>
  GENERATE_URL(`${PREFIX_URL}/CalculateMultipleCycle`, options);

export const CalculateCycleSelection = (options) =>
  GENERATE_URL(`${PREFIX_URL}/CalculateCycleSelection`, options);

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
  CalculateCycle,
  UpdateLockStatus,
  GetCycleLogs,
  ReactivateCycle,
  GetCycleList,
  CalculateMultipleCycle,
  CalculateCycleSelection,
};
